import { render, staticRenderFns } from "./WidgetEditorNuovo.vue?vue&type=template&id=7afff166&scoped=true"
import script from "./WidgetEditorNuovo.vue?vue&type=script&lang=js"
export * from "./WidgetEditorNuovo.vue?vue&type=script&lang=js"
import style0 from "./WidgetEditorNuovo.vue?vue&type=style&index=0&id=7afff166&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7afff166",
  null
  
)

export default component.exports